import styles from './DashboardHeading.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  ScreenReaderOnly,
  ChevronIcon,
  Text,
  Hidden
} from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

import { isUndefined } from 'lodash';

export default class DashboardHeading extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Icon: PropTypes.func.isRequired,
    iconClass: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    analytics: PropTypes.string.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {
      label,
      count,
      Icon,
      iconClass,
      className,
      href,
      analytics
    } = this.props;
    return (
      <NavLink
        className={classnames(styles.root, className)}
        location={href}
        analytics={analytics}
      >
        <ScreenReaderOnly>
          <h1>{`${isUndefined(count) ? `${count} ` : ''} ${label}`}</h1>
        </ScreenReaderOnly>

        <Icon headline className={iconClass} svgClassName={styles.iconSvg} />
        <Text subheading regular>
          {isUndefined(count) ? null : (
            <span
              aria-hidden="true"
              className={styles.count}
              data-automation="dashboardHeadingCount"
            >
              {count}
            </span>
          )}
          <span aria-hidden="true" className={styles.name}>
            {label}
            <Hidden desktop>
              <ChevronIcon className={styles.chevron} direction="right" />
            </Hidden>
          </span>
        </Text>
      </NavLink>
    );
  }
}
